const RulesEngine = () => (
  <div>
    <h1>Rule Engine</h1>
  </div>
);

export default RulesEngine;
